import { MentionCP } from 'main/common/components/form-fields/mention/MentionCP'
import { ProgressCP } from 'main/common/components/progress/ProgressCP'
import { TextCP } from 'main/common/components/text/TextCP'
import { IFormStateManager } from 'main/common/form-state-manager/IFormStateManager'
import { MARKETING_CONTENT_VARS } from 'main/modules/marketing/config/MarketingContentVarsConfig'
import React, { useState } from 'react'
import { MarketingContentVarsConfigTP } from 'main/modules/marketing/types/MarketingContentVarsConfigTP'

const TOTAL_CHARS_BY_MSG = 160

interface ISmsTextAreaCPProps {
    formStateManager: IFormStateManager<any>
    fieldName: string
    label: string
    value?: string
    onChange?: (text: string) => void
    showPercentage?: boolean
    considerCharLimit: boolean
    mentionOptions?: MarketingContentVarsConfigTP[]
}

/**
 * Text area para texto de SMS, autocompleta com as variaveis que podem ser utilizadas
 */
export function SmsTextAreaCP(props: ISmsTextAreaCPProps): JSX.Element {

    const [msgPercent, setMsgPercent] = useState<number>(0)
    const [totalChars, setTotalChars] = useState<number>(0)

    /**
     * Ao mudar o valor.
     */
    function onChange(text: string): void {
        setTotalChars(text.length)
        setMsgPercent(Math.ceil((text.length / TOTAL_CHARS_BY_MSG) * 100))

        props.onChange?.(text)
    }

    return (
        <>
            <MentionCP
                label={props.label}
                prefix={'#'}
                required={true}
                formStateManager={props.formStateManager}
                fieldName={props.fieldName}
                options={props.mentionOptions ?? MARKETING_CONTENT_VARS}
                onChange={onChange}
                rows={3}
                maxLength={props.considerCharLimit ? TOTAL_CHARS_BY_MSG : undefined}
            />

            {
                props.considerCharLimit &&
                <>
                    <ProgressCP percent={msgPercent} showInfo={false}/>
                    <TextCP text={`Caracteres restantes: ${totalChars}/${TOTAL_CHARS_BY_MSG}`}/>
                </>
            }
        </>
    )
}
